import React, { useState, useCallback, useRef } from "react";
import { useAppDispatch, useAppSelector } from "@lib";
import {
  setCurrentPolicyNumber,
  toogleLoading,
  updatePolicy,
} from "@lib";
import { usePolicies } from "@lib";
import { usePolicyDetails } from "@lib/hooks/policyScreen/usePolicyDetails";
import { getPolicyNumber } from "@lib/utilities/Helpers";
import { useFocusEffect } from "@react-navigation/native";

export const withPolicyDataFetching = (WrappedComponent: any) => {
  return (props: any) => {
    const [policyData, setpolicyData] = useState<any>([]);
    const dispatch = useAppDispatch();

    const { getPolicies } = usePolicies();
    const { fetchPolicyDetails } = usePolicyDetails(policyData);
    const { policies, policyNumber } = useAppSelector(
      (state) => state?.policyReducer
    );

    const policyDetail = useAppSelector((state) => state?.policyDetailReducer);
    const hasFetchedPoliciesRef = useRef(false);
    const lastPolicyDetailFetchedRef = useRef<any>(null);

    useFocusEffect(
      useCallback(() => {
        const fetchData = async () => {
          try {
            dispatch(toogleLoading(true));
            const responseObj: any = await getPolicies();
            const prevPolicyNumber = await getPolicyNumber();
            if (responseObj) {
              dispatch(updatePolicy(responseObj?.response));
              setpolicyData(responseObj?.response);
              if (prevPolicyNumber) {
                const selectedPolicy = responseObj?.response?.find(
                  (item: any) => item.policyNumber === prevPolicyNumber
                );
                if (selectedPolicy) {
                  dispatch(setCurrentPolicyNumber(selectedPolicy.policyNumber));
                }
              }
            }
            dispatch(toogleLoading(false));
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };

        const fetchPolicyDetailsHandler = async () => {
          if (
            !policyDetail?.policyNumber ||
            policyNumber != policyDetail.policyNumber
          ) {
            await fetchPolicyDetails();
          }
        };

        if (!policies.length && !hasFetchedPoliciesRef.current) {
          hasFetchedPoliciesRef.current = true;
          fetchData().catch(() => {
            hasFetchedPoliciesRef.current = false;
          });
        }

        if (policyNumber) {
          if (lastPolicyDetailFetchedRef.current !== policyNumber) {
            lastPolicyDetailFetchedRef.current = policyNumber;
            fetchPolicyDetailsHandler().catch(() => {
              lastPolicyDetailFetchedRef.current = null;
            });
          }
        }
      }, [policyNumber, policyDetail.policyNumber])
    );

    return <WrappedComponent {...props} policyData={policyData} />;
  };
};
